import { useQuery } from '@tanstack/react-query';

import * as overlayServices from 'services/overlay';
import * as overlayEndpoints from 'services/overlay/endpoints';

const queryMemberForCreateEditOverlay = {
  url: overlayEndpoints.GET_ALL_OVERLAY_MEMBERS,
  all: ['pim/overlays', 'get-all-overlay-members'],
  params: (searchText) => [
    ...queryMemberForCreateEditOverlay.all,
    { payload: { searchText } },
  ],
};

const keys = {
  queryMemberForCreateEditOverlay,
};

export const useQueryMembersForCreateOrRetargetMember = (
  searchText,
  options
) => {
  return useQuery({
    queryKey: keys.queryMemberForCreateEditOverlay.params(searchText),
    queryFn: async () => {
      const params = { searchText, PageIndex: '1', PageSize: '9999' };

      const response = await overlayServices.getAllOverlayMembers(params);

      const { isSuccess, message, data } = response || {};

      if (isSuccess) {
        return Promise.resolve(data || {});
      } else {
        return Promise.reject(message || 'Sever Error');
      }
    },
    ...options,
  });
};
